import { SignInButton } from '@clerk/clerk-react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export function HeroSection() {
  return (
    <section className="pt-32 pb-20 px-6 min-h-screen flex items-center">
      <div className="max-w-4xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Logos */}
          <div className="flex items-center justify-center gap-8 mb-12">
            <img 
              src="/TemasekHoldings_logo.svg" 
              alt="Temasek Holdings" 
              className="h-16"
            />
            <div className="text-4xl font-light text-gray-400">×</div>
            <img
              src="/tomorologoblue.png"
              alt="Tomoro"
              className="h-12 md:h-14"
            />
          </div>
          
          {/* Main Title */}
          <div className="mb-10 flex justify-center">
            <img
              src="/advancelogo.png"
              alt="Advance"
              className="h-16 md:h-20"
            />
          </div>

          <p className="text-2xl text-gray-600 mb-12 font-light">
            Innovation Workshop Dashboard
          </p>
          
          {/* CTA */}
          <SignInButton mode="modal">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="px-10 py-4 bg-black text-white rounded-xl font-medium text-lg flex items-center justify-center gap-3 hover:bg-gray-900 transition-colors mx-auto"
            >
              Get Started
              <ArrowRight className="w-5 h-5" />
            </motion.button>
          </SignInButton>
        </motion.div>
      </div>
    </section>
  );
}
